import styled from 'styled-components'
import breakpoint from 'styled-components-breakpoint'

export const FormActions = styled.div`
    margin-bottom: 0.8rem;

    a {
        display: block;
        margin-right: 0.8rem;
        margin-bottom: 0.8rem;
        font-weight: 400;
        cursor: pointer;

        ${breakpoint('laptop')`
            display: inline-flex;
            align-items: center;
            margin-bottom: 0;
        `};

        &:last-child {
            margin-right: 0;
        }
    }
`
